export default __webpack_public_path__ + "static/media/Anfield.7b1660e0.jpg";